import type { IconSvgElement } from "@hugeicons/react";
import {
  File02Icon,
  FilterIcon,
  House03Icon,
  IdentityCardIcon,
  PlazaIcon,
  SquareLock02Icon,
  UserCircleIcon
} from "@hugeicons-pro/core-stroke-rounded";
import type { MasterSearchEntityType } from "api/masterSearch";

export const MASTER_SEARCH_PLACEHOLDER = "Search by name, email, phone…";

export const MIN_QUERY_LENGTH = 2;

// Server caps at 10 per group; ask for the maximum so the palette truncates as
// little as possible (the group badge reports "N of total" either way).
export const MASTER_SEARCH_LIMIT = 10;

// Base labels. `property`/`listing` are overridden at render time via
// useUnitsPropertiesDictionary (sites_and_communities partners see
// "Communities" / "Sites"). The listing group shows unit rows — every unit,
// not just listed ones — hence "Units".
export const ENTITY_TYPE_LABELS: Record<MasterSearchEntityType, string> = {
  lead: "Leads",
  contact: "Contacts",
  screen_applicant: "Applicants",
  report_renter: "Renters",
  property: "Properties",
  listing: "Units",
  lockbox: "Lockboxes"
};

export const ENTITY_TYPE_ICONS: Record<MasterSearchEntityType, IconSvgElement> =
  {
    lead: FilterIcon,
    contact: IdentityCardIcon,
    screen_applicant: File02Icon,
    report_renter: UserCircleIcon,
    property: House03Icon,
    listing: PlazaIcon,
    lockbox: SquareLock02Icon
  };

export const ENTITY_TYPE_ORDER: MasterSearchEntityType[] = [
  "lead",
  "contact",
  "screen_applicant",
  "report_renter",
  "property",
  "listing",
  "lockbox"
];
